module.exports = __webpack_public_path__ + "img/mq.3acccce1.png";